import React from 'react'
import {
  CFView,
  CFImage,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { awardLogo, mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center textCenter mt="15px">
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="15px auto" maxWidth="1400px">
          <a href="">
            <CFImage
              mv="15px"
              width="100%"
              maxWidth="150px"
              src="https://threebestrated.ca/awards/sushi-chilliwack-2024-drk.svg"
              alt="Best Sushi in Chilliwack"
            />

            <CFImage
              mv="15px"
              width="100%"
              maxWidth="150px"
              src="https://threebestrated.ca/awards/sushi-chilliwack-2025-drk.svg"
              alt="Best Sushi in Chilliwack"
            />
            <CFImage
              mv="15px"
              width="100%"
              maxWidth="150px"
              src="https://threebestrated.ca/awards/sushi-chilliwack-2026-drk.svg"
              alt="Best Sushi in Chilliwack"
            />
          </a>
          <CFImage src={promotions} w="100%" alt="Promotions" mt="-25px" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
